import React from 'react';
import HeaderSmall from '../Components/Header/HeaderSmall';
import { connect } from 'react-redux'
import { resourceApi } from '../utils/fetchUtil';
import Lightbox from 'react-image-lightbox';
import { Divider, ListItem, Paper, Avatar } from 'material-ui';
import TabStrip  from '../Components/TabStrip';
import ChevronRight from 'material-ui/svg-icons/navigation/chevron-right';
import './InsuranceCard.css';

const isApple  = /iPhone|iPad|iPod/i
.test(navigator.userAgent);

const isAndroid  = /Android/i
.test(navigator.userAgent);


class InsuranceCard extends React.Component {


    constructor(props) {
        super(props);
        this.state = {  
            wallet:[],
        };
    }

    componentDidMount() {
        this.loadInsuranceCard();
    }

    loadInsuranceCard = () => {
        let config = {
            method: 'get',
            url: 'member/insurancecards/v2'
        }

        resourceApi(config)
        .then((r)=>{
            let cards = r.data.sort((a, b) => b.Ordinal > a.Ordinal ? -1 : 1 )
            this.setState({wallet:cards})
        })
    }

    lightItUpBox = (v) => {
        this.setState({images:v.InsuranceCards, photoIndex:0, isOpen: true}, ()=>{ this.logView(v) })
    }

    logView = (cardsVM) => {
        if(cardsVM && cardsVM.ClientInsuranceCardID){
            let config = {
                method : "get",
                url : `member/insurancecards/v2/log/${cardsVM.ClientInsuranceCardID}`
            }
            resourceApi(config)
            .then()
            .catch();
        }
    }

    close = () => {
        
        if(isApple || isAndroid) {
            if(window.screen.orientation) {
                try{
                    window.screen.orientation.unlock();
                }
                catch(err) {
                    
                }
            }
        }

        this.setState({ isOpen: false, images: [],  photoIndex:0})
    }
            
    // getContent(data) {
    //   return {__html: data};
    // }
  
    render() {

        // const customStyles = {
        //     content : {
        //       top                   : '50%',
        //       left                  : '50%',
        //       right                 : 'auto',
        //       bottom                : 'auto',
        //       marginRight           : '-50%',
        //       transform             : 'translate(-50%, -50%)'
        //     }
        //   };

        const { photoIndex, isOpen, images } = this.state;

        return (
            <div>
                <HeaderSmall title="Insurance Cards"  /> 
                <div className="container trueno" style={{marginTop: 50}}>
                            <div>
                            {Array.isArray(this.state.wallet) && this.state.wallet.map((v,i) => (
                                <div key={i}>
                                    <Paper>
                                            <ListItem 
                                            style={{height:85, paddingTop:5}}
                                                primaryText={<b>{(v.Name ? v.Name : "Benefit Card")}</b>}
                                                secondaryText={v.SubTitleText ? <p>{v.SubTitleText}</p> : <p>Click to view your card</p> }
                                                secondaryTextLines={2}
                                                onClick={() => this.lightItUpBox(v)}
                                                leftAvatar={<div className={`insurance-card-avatar ${v.Type}`}>&nbsp;</div>
                                                }
                                                rightIcon={<div style={{paddingTop:15}}><ChevronRight /></div>}
                                            />
                                    </Paper>
                                    <br/>
                                </div>
                            ))}
                            </div>
                    
                  {isOpen && (
                            <Lightbox
                                
                                mainSrc={images[photoIndex].Url}
                                nextSrc={images[(photoIndex + 1) % images.length].Url}
                                prevSrc={images[(photoIndex + images.length - 1) % images.length].Url}
                                onCloseRequest={this.close}
                                onMovePrevRequest={() =>
                                this.setState({
                                    photoIndex: (photoIndex + images.length - 1) % images.length,
                                })
                                }
                                onMoveNextRequest={() =>
                                this.setState({
                                    photoIndex: (photoIndex + 1) % images.length,
                                })
                                }
                            />
                        )}


                    {/* {(images.length === 0) && (this.props.insuranceCards) && (
                        this.props.insuranceCards.map((item, index) => 
                            <div>
                                <Card style={{minHeight: 85}}>
                                    <CardHeader
                                        textStyle={{width:'90%', paddingRight:0, paddingTop:0}}
                                        title={<h3>{item.Name}</h3>}
                                        actAsExpander={true}
                                        showExpandableButton={true}
                                        
                                    />
                                    <CardText expandable={true} style={{fontSize:16, marginTop:0, paddingTop: 0}}  >
                                        {(item.IconClass) && (
                                            <div style={{marginTop:15}}>
                                                <div className={item.IconClass} />
                                            </div>
                                        )}

                                        {(item.Url) && (
                                            <div style={{marginTop:15}}>
                                                <a style={{ textDecoration:"none"}} onClick={()=>{fireInAppBrowserPlugin(`${item.Url}`)}}>{item.Url}</a> 
                                                <br />
                                            </div>
                                        )}

                                        {(item.Phone) && (
                                            <div style={{marginTop:15}}>
                                                <a style={{ textDecoration:"none"}} onclick={()=>{fireInAppBrowserPlugin(`tel:${item.Phone}`)}}>
                                                    {item.Phone}
                                                </a>
                                                <br />
                                            </div>
                                        )}

                                        {(item.Email) && (
                                            <div style={{marginTop:15}}>
                                                    <a style={{ textDecoration:"none"}} onclick={()=>{fireInAppBrowserPlugin(`mailto:${item.Email}`)}}>
                                                    {item.Email}
                                                </a>
                                                <br />
                                            </div>
                                        )}
                                        {(item.LineItems) && (item.LineItems.length > 0) && (
                                            
                                            <div>
                                                <table>
                                                    {item.LineItems.map((row, index) => (
                                                        <tr>
                                                            <td>{row.Item}</td>
                                                            <td>{row.Value}</td>
                                                        </tr>
                                                    ))}
                                                </table>
                                            </div>
                                        )}
                                        <div dangerouslySetInnerHTML={this.getContent(item.Description)} />
                                    </CardText>
                                </Card>
                            <br />
                        </div>
                    ))} */}
                </div>
                <br />
                <br />
                <br />
                <TabStrip activeTab={1} />
            </div>

        );
    }
};

// const mapDispatchToProps = (dispatch) => {
//   return {
//     loadInsuranceCard: () => {
//         dispatch(loadInsuranceCard());
//     }
//   }
// }

// const mapStateToProps = (state) => ({
//     insuranceCards: state.thisApp.member.insuranceCards
// })

export default connect(
//   mapStateToProps,
//   mapDispatchToProps
)(InsuranceCard)



// WEBPACK FOOTER //
// ./src/Pages/InsuranceCard.js